import { useTranslation } from "react-i18next";
import MokaPosLogo from "../../components/paymentSystems/MokaPosLogo";
import TinkoffLogo from "../../components/paymentSystems/TinkoffLogo";

import style from "../../sass/custom/buttons.module.scss";
import NestpayLogo from "../../components/paymentSystems/NestpayLogo";
import { useEffect, useState } from "react";
import { Button } from "@mui/material";

const SelectPaymentSystem = ({
    goBack,
    handleMokaPayClick,
    handleTinkoffPayClick,
    handleNestpayClick,
}) => {
    const {t} = useTranslation()

    const [windowSize, setWindowSize] = useState(
        window.innerWidth,
      );
    
      useEffect(() => {
        const handleWindowResize = () => {
          setWindowSize(window.innerWidth);
        };
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
      }, []);



    return (
        <div className="w-full px-5 pb-3">
            <div>
                <div className="text-left mb-2 text-sm font-medium">
                    {t("bills.bill_info.select_currency")}
                </div>
            </div>
            <div className="flex justify-between w-full">
                <div 
					className="cursor-pointer" 
					onClick={handleMokaPayClick}
				>
                    <MokaPosLogo height={windowSize > 400 ? 35 : 30} />
                </div>

                <div 
					className="cursor-pointer" 
					onClick={handleTinkoffPayClick}
				>
                    <TinkoffLogo height={windowSize > 400 ? 35 : 30} />
                </div>

                <div 
					className="cursor-pointer hidden" 
					onClick={handleNestpayClick}
				>
                    <NestpayLogo height={windowSize > 400 ? 35 : 30} />
                </div>
            </div>

            <div className="mt-3 w-fit">
                <Button
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#dc2626",
                        fontSize: "0.5rem",
                        padding: "0.25rem 1rem",
                        width: "fit-content%",
                        ":hover": {
                            bgcolor: "#b91c1c",
                        },
                    }}
                    onClick={goBack}
                >
				    {t("bills.bill_info.go_back")}
			    </Button>
            </div>
        </div>
    );
};

export default SelectPaymentSystem;
